export default __webpack_public_path__ + "logo_400w_light.png";